import { Campaign } from '@hprofits/api';
import { UserId } from '@hprofits/shared';
import { computed, Ref, toValue } from 'vue';

type UseOwnerInfoResult = Readonly<{
  ownerId: Readonly<Ref<UserId | null>>;
  ownerEmail: Readonly<Ref<string | null>>;
}>;

export const useCampaignOwnerInfo = (campaign: Readonly<Ref<Campaign | null>>): UseOwnerInfoResult => {
  const ownerEmail = computed(() => {
    const data = toValue(campaign);
    return data?.view === 'admin' ? data.owner.email : null;
  });

  const ownerId = computed(() => {
    const data = toValue(campaign);
    return data?.view === 'admin' ? data.owner.id : null;
  });

  return {
    ownerId,
    ownerEmail,
  };
};
